import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Footer from 'src/components/footer/footer';

function FomoAviatorWingsofAdventure(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 39 || brandId == 40) ? "FOMO7" : 'iw247';


    return (
        <>
            <InformationWrapper>
                <HeadWrapper>
                    <p>This World Cup, experience aviator like never before! This is a thrilling opportunity for all aviator enthusiasts to take their gaming experience to new heights!</p>
                    <p>Be a part of Aviator's Skybound Miles and immerse yourself in the thrilling world of virtual aviation!</p>
                    <p>Get set to <span className='yellow'>win INR 7 lakhs monthly, INR 70 thousand weekly & INR 700 daily.</span></p>
                </HeadWrapper>
                <Divider></Divider>
                <LoyaltyWrapper>
                    <HeadingText className='titleText'>
                        <h1>Embark on a Winning Adventure</h1>
                    </HeadingText>
                    <UnderLine></UnderLine>
                </LoyaltyWrapper>
                <JoiningWrapper>
                    <JoiningContainer>
                        <JoiningContent>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.FomoAviatorWingsOfAdventureRoImgOne}`}
                                alt="jetxPromoStepThree"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <h2>Register</h2>
                            <UnderLine></UnderLine>
                            <p>Create a {domain} account if you do not have one yet. Register with your name and mobile number. Experience the world of Aviator only on {domain}!</p>
                        </JoiningContent>
                        <JoiningContent>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.FomoAviatorWingsOfAdventureRoImgThree}`}
                                alt="jetxPromoStepThree"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <h2>Deposit</h2>
                            <UnderLine></UnderLine>
                            <p>Deposit using any method and head to Aviator!</p>
                        </JoiningContent>
                        <JoiningContent>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.FomoAviatorWingsOfAdventureRoImgTwo}`}
                                alt="jetxPromoStepThree"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <h2>Bet and Win</h2>
                            <UnderLine></UnderLine>
                            <p>Place as many bets as you can and stand a chance to <span className='yellow'>win INR 7,00,000!</span></p>
                        </JoiningContent>
                    </JoiningContainer>
                </JoiningWrapper>
                <ROWrapper>
                    <RoContent>
                        <h1>Aviator – Wings of Adventure!</h1>
                        <UnderLine></UnderLine>
                        <p>Embark on an exhilarating journey with Aviator, where every bet you place brings you closer to incredible rewards, Daily!</p>
                        <p>Start playing today and make every bet count!</p>
                        <p>Scheme valid from <span className='yellow'>2nd June to 29th June 2024</span></p>
                    </RoContent>
                </ROWrapper>
                <TableWrapper>
                    <HeadingText className='titleText'>
                        <h1>Prize Allocation</h1>
                    </HeadingText>
                    <UnderLine></UnderLine>
                    <LazyLoadImage
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.FomoAviatorWingsOfAdventureTable}`}
                        alt="jetxPromoStepThree"
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                </TableWrapper>
                <Termsandconditions>
                    <TermsandconditionsHeading>
                        <h1>Terms & Conditions</h1>
                    </TermsandconditionsHeading>
                    <UnderLine></UnderLine>
                    <TermsandconditionsBody>
                        <ol>
                            <li>This promotion is valid for all players.</li>
                            <li>Aviator's Skybound Miles is valid from 2nd June to 29th June 2024.</li>
                            <li>The winners will be chosen based on highest bet amount.</li>
                            <li>No Minimum bet amount required to enter this contest.</li>
                            <li>No Minimum odds to be maintained.</li>
                            <li>Void/Cancelled/Draw bets, Cashed-Out bets do not count towards the deposit or bonus rollover requirements.</li>
                            <li>Multiple accounts will not be considered for this promotion eligibility / criteria. All players will be subject for duplicate checking. {domain} reserves the right to disqualify players if collusion or any foul play takes place in the promotion.</li>
                            <li>{domain} reserves the right to amend, cancel and reclaim or refuse any promotion at its own discretions.</li>
                            <li>{domain} General Terms & Conditions apply.</li>
                        </ol>
                    </TermsandconditionsBody>
                </Termsandconditions>
            </InformationWrapper>
            <Footer />
        </>
    )
}



export default withTheme(withAppContext(FomoAviatorWingsofAdventure));

export const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 0 3rem 8rem 3rem;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    border: 1px solid #E5B358;
    border-radius: 0 0 20px 20px;
    border-top-color: transparent;
    backdrop-filter: brightness(0.5);    
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.FomoAviatorWingsOfAdventureBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
`;

const HeadWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5rem 20% 3rem 20%;
    gap: 1rem;

    p {
        margin: 0;
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 160.3%; /* 25.648px */
    }

    .yellow {
        color: #FEBA3B;
        font-weight: 700;
        text-transform: capitalize;
    }
`;

const LoyaltyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
    padding: 3rem;
    margin: 0 -2rem;

    .joiningTxt {
        padding-top: 1.5rem;
    }

    .titleText {
        padding: 1rem 0 1.2rem 0;
        h1 {
            margin: 0;
        }
    }
`;

const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem;
    margin: 0 -3rem;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.FomoAviatorWingsOfAdventureTableBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    text-align: center;

    .titleText {
        padding: 1rem 0 1.2rem 0;
        h1 {
            margin: 0;
        }
    }

    p {
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 120.3%; /* 19.248px */
    }

    img {
        padding-top: 3rem;
        width: 50%;
    }
`;

const HeadingText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    h1 {
        text-align: center;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 1.25px;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 91.67%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    p {
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 120.3%; /* 19.248px */
    }
`;

export const UnderLine = styled.div`
    height: 2px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);
`;

export const Divider = styled.div`
    height: 2px;
    width: 100%;
    background: radial-gradient(#1182C1 0%, #00000000 50%);
`;

const JoiningWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: -999;
    margin: 0 -3rem;
`;

const JoiningContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    gap: 3rem;
    padding: 2rem 0 3rem 0;
`;

const JoiningContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 5rem 1.5rem 2rem 1.5rem;
    width: 20%;
    border-radius: 10px;
    border: 0.8px solid rgba(255, 255, 255, 0.50);
    background: radial-gradient(136.33% 139.78% at 0% 0%, rgba(254, 186, 59, 0.00) 63.5%, rgba(254, 186, 59, 0.20) 100%), radial-gradient(136.33% 139.78% at 0% 0%, rgba(255, 95, 31, 0.20) 0%, rgba(255, 95, 31, 0.00) 53.5%), rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(12.5px);
    position: relative;

    p {
        margin-bottom: 0;
        color: #FFF;
        text-align: left;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 145%; /* 23.2px */
    }

    .yellow {
        color: #FEBA3B;
        font-weight: 700;
    }

    img {
        width: 10rem;
        position: absolute;
        right: 2%;
        bottom: 65%;
    }

    h2 {
        color: #FEBA3B;
        text-align: left;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 145%; /* 29px */
        text-transform: capitalize;
        margin: 0;
        padding-bottom: 1rem;
        width: 100%;
    }
`;

const ROWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    border-radius: 30px;
    width: 85%;
    height: auto;
    margin: 1rem 7.5% 3rem 7.5%;
    padding: 8rem 3rem;
    /* padding-left: 40rem; */
    position: relative;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.FomoAviatorWingsOfAdventureRoBackground")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    ::after {
        position: absolute;
        top: -2px; bottom: -2px;
        left: -2px; right: -2px;
        background: linear-gradient(90deg, #53C1FF, black, #53C1FF, black, #53C1FF);
        content: '';
        z-index: -1;
        border-radius: 30px;
    }
`;

const RoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 45%;
    /* padding-right: 9rem; */

    h1 {
        margin: 0;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 91.67%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 1.25px;
        text-align: left;
    }

    p {
        margin: 0;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 120.3%; /* 19.248px */
        text-align: left;
    }

    .yellow {
        color: #FEBA3B;
        font-weight: 700;
    }
`

const Termsandconditions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    width: 75%;
    height: auto;
    margin: 1rem 12.5% 3rem 12.5%;
    padding: 5rem 3rem;
    position: relative;
    background: linear-gradient(#020405, rgba(0, 0, 0, 0.935), #020405);
    background-clip: padding-box;
    border: 2px solid transparent;

    ::after {
        position: absolute;
        top: -2px; bottom: -2px;
        left: -2px; right: -2px;
        background: linear-gradient(90deg, #53C1FF, black, #53C1FF, black, #53C1FF);
        content: '';
        z-index: -1;
        border-radius: 30px;
    }
`;

const TermsandconditionsHeading = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;    
    padding-bottom: 2rem;

    h1 {
        margin: 0;
        padding: 0;
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 121.53%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 1.25px;
    }
`;

const TermsandconditionsBody = styled.div`
    ol {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        padding-top: 1rem;
    }
    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;